import { render, staticRenderFns } from "./FissionPosters.vue?vue&type=template&id=b518f476&"
import script from "./FissionPosters.vue?vue&type=script&lang=js&"
export * from "./FissionPosters.vue?vue&type=script&lang=js&"
import style0 from "./FissionPosters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports